import { render, staticRenderFns } from "./SwitchMapGeoNovation.vue?vue&type=template&id=3021e4c7&"
import script from "./SwitchMapGeoNovation.vue?vue&type=script&lang=js&"
export * from "./SwitchMapGeoNovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports